import React from "react";
import { qhseBg } from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Upper = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Upper & lower completion & installation of downhole equipment" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto ">
          <p className="mt-6 text-[20px] font-semibold text-[#141615]">
            {t("Upper & lower completion & installation of downhole equipment")}
          </p>
          <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
            {t(
              "Caspian Rock Solutions Holding renders engineering support service of technological equipment, carries out set up and provides control over facilities’ operation, calculates the patency and eccentricity of the columns."
            )}
          </p>
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Technological equipment of casing columns:")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Centralized products")}</li>
                <li>{t("Float equipment")}</li>
                <li>{t("Equipment for two-stage cementing")}</li>
                <li>{t("Casing swelling packers")}</li>
                <li>{t("Plugs")}</li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Equipment for wells completion:")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Liner hangers")}</li>
                <li>{t("Hydraulic packers")}</li>
                <li>{t("PShutoff valvesorosity")}</li>
              </ul>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 mt-8 md:mt-0">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Equipment for lower and upper completion:")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Inflow control systems")}</li>
                <li>{t("Equipment for hydraulic fracturing")}</li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Service support:")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>
                  {t(
                    "Running and cementing of casing. Detailed study of the technical parameters of the well, the determination of the types and quantities of tooling, the calculation of the patency of columns, the adjustment of equipment, support during running.  "
                  )}
                </li>
                <li>
                  {t(
                    "Upper and lower completion services. One of the activity directions is the implementation of third-party contractors. At the expense of accumulating large volumes of key jobs in one hands and using of various financial instruments, we give the contractor an opportunity to optimize their expenses, which in turn allows them to reduce the cost of their services significantly."
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Upper;
